import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

export const ReadMore = ({ id, text, cssClass, words = 36, chars }) => {

    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    let itCanOverflow;
    let beginText;
    let endText;

    if (chars) {
        itCanOverflow = text.length > chars;
        beginText = itCanOverflow ? text.slice(0, chars) : text;
        endText = itCanOverflow ? text.slice(chars) : '';
    } else {
        const splittedText = text.split(' ');
        itCanOverflow = splittedText.length > words;
        beginText = itCanOverflow
            ? splittedText.slice(0, words - 1).join(' ')
            : text;
        endText = splittedText.slice(words - 1).join(' ');
    }

    const handleKeyboard = (e) => {
        if (e.code === 'Space' || e.code === 'Enter') {
            setIsExpanded(!isExpanded);
        }
    }

    return (
        <div id={id} className={`${cssClass}`}>
            {parse(beginText)}
            {itCanOverflow && (
                <>
                    {!isExpanded && <span>... </span>}
                    <span
                        className={`${!isExpanded && 'hidden'}`}
                        aria-hidden={!isExpanded}
                    >
                        {' '}{parse(endText)}
                    </span>
                    <span
                        className={`text-info ml-1`}
                        role="button"
                        tabIndex={0}
                        aria-expanded={isExpanded}
                        aria-controls={id}
                        onKeyDown={handleKeyboard}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? t('labels.showLess') : t('labels.showMore')}
                    </span>
                </>
            )}
        </div>
    )
}